<form>
  <div class="card mb-0">
    <div class="card-header">
      <h3 class="card-title text-center mb-0">{{ title }}</h3>
      <button *ngIf="!isButtonShow" type="button" class="close confirm-close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="card-body" [innerHTML]="message">
    </div>
    <div *ngIf="isButtonShow" class="card-footer text-right d-flex justify-content-between">
      <div></div>
      <div class="d-flex flex-wrap align-items-center gap-2">
        <button type="button" class="btn btn-primary saveDial" (click)="accept()">{{ btnOkText }}</button>
        <button type="button" class="btn btn-dark" (click)="decline()">{{ btnCancelText }}</button>
      </div>
    </div>
  </div>
</form>